export function toUpperAndTrim(text: string): string {
    if (!text) {
        return text
    }

    return text.toUpperCase().trim()
}

export function createGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8
        return v.toString(16)
    })
}

export function rightPad(str: string, length: number, padChar: string) {
    if (str.length >= length) {
        return str
    }
    const padLength = length - str.length
    const padding = padChar.repeat(padLength).slice(0, padLength)
    return str + padding
}
